import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Divider from '@material-ui/core/Divider';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { format } from 'date-fns';
import { FaWindowClose } from 'react-icons/fa';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/geral.css';
import { PendenciasWizard, setPendencia } from './ValidacaoWizard';

class ItensCirurgia extends Component {
  state = {
    openModal: false,
    caixasOPME: [],
    materiaisConsumiveis: [],
    caixasCirurgicas: [],
    hemoderivados: [],
    equipamentos: [],
    exames: [],
    handleFuncaoQuantidadeItem: undefined,
    listaProcedimento: [],
    listaProcedimentoPrincipal: [],
    listaProcedimentoSecundario: [],
    listaCaixasOPME: [],
    listaMaterialConsumivel: [],
    listaCaixasCirurgicas: [],
    listaHemoderivados: [],
    listaEquipamentos: [],
    listaExames: [],
    procedimentoPrincipal: null,
    procedimentosSecundarios: [],
    duracaoEstimada: null,
    duracaoEstimadaDesabilitada: false,
    diariasPrevistas: null,
    diariaPrevistaDesabilitada: false,
    openModalMedida: false,
    listaUnidadeMedida: [],
    unidadeMedida: null,
    pedidosCirurgiaPacienteProcedimento: [],
    abrePedidoCirurgiaPacienteProcedimento: false,
    continuaProcedimentoDuplicado: false,
    novoPaciente: null,
    configuracoes: null,
    checkItemEventual: false,
    justificativaEventual: null,
    modalProcedimento: false,
  };

  alimentaStates = () => {
    const caixasOPME = localStorage.getItem('caixasOPME');
    const materiaisConsumiveis = localStorage.getItem('materiaisConsumiveis');
    const caixasCirurgicas = localStorage.getItem('caixasCirurgicas');
    const hemoderivados = localStorage.getItem('hemoderivados');
    const equipamentos = localStorage.getItem('equipamentos');
    const procedimentoPrincipal = localStorage.getItem('procedimentoPrincipal');
    const procedimentosSecundarios = localStorage.getItem('procedimentosSecundarios');
    const duracaoEstimada = localStorage.getItem('duracaoEstimada');
    const duracaoEstimadaMinimaPermitida = localStorage.getItem('duracaoEstimadaMinimaPermitida');
    const duracaoEstimadaMaximaPermitida = localStorage.getItem('duracaoEstimadaMaximaPermitida');
    const examesAtendimento = localStorage.getItem('examesAtendimento');
    const exames = localStorage.getItem('exames');
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const diariasPrevistasMinima = localStorage.getItem('diariasPrevistasMinima');
    const diariasPrevistasMaxima = localStorage.getItem('diariasPrevistasMaxima');
    const novoPaciente = JSON.parse(localStorage.getItem('novoPaciente'));
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

    if (duracaoEstimada) {
      this.setState({ duracaoEstimada });
      setPendencia(2, PendenciasWizard.duracaoEstimada);
    }
    if (
      duracaoEstimadaMinimaPermitida &&
      duracaoEstimadaMaximaPermitida &&
      duracaoEstimadaMinimaPermitida === duracaoEstimadaMaximaPermitida
    ) {
      this.setState({
        duracaoEstimada: duracaoEstimadaMinimaPermitida,
        duracaoEstimadaDesabilitada: true,
      });
      localStorage.setItem('duracaoEstimada', duracaoEstimadaMinimaPermitida);
      setPendencia(2, PendenciasWizard.duracaoEstimada);
    }
    if (caixasOPME) this.setState({ caixasOPME: JSON.parse(caixasOPME) });
    if (materiaisConsumiveis)
      this.setState({ materiaisConsumiveis: JSON.parse(materiaisConsumiveis) });
    if (caixasCirurgicas) this.setState({ caixasCirurgicas: JSON.parse(caixasCirurgicas) });
    if (hemoderivados) this.setState({ hemoderivados: JSON.parse(hemoderivados) });
    if (equipamentos) this.setState({ equipamentos: JSON.parse(equipamentos) });
    if (procedimentoPrincipal) {
      this.setState({ procedimentoPrincipal: JSON.parse(procedimentoPrincipal) });
      setPendencia(2, PendenciasWizard.procedimentoPrincipal);
      if (!diariasPrevistas) {
        this.sugerirDiariasPrevistas(procedimentoPrincipal);
      }
    }
    if (procedimentosSecundarios) {
      this.setState({ procedimentosSecundarios: JSON.parse(procedimentosSecundarios) });
    }
    if (exames) this.setState({ exames: JSON.parse(exames) });
    if (diariasPrevistas) {
      this.setState({ diariasPrevistas });
      setPendencia(2, PendenciasWizard.diariasPrevistas);
    } else if (!diariasPrevistasMinima && !diariasPrevistasMaxima) {
      this.sugerirDiariasPrevistas(procedimentoPrincipal);
      if (examesAtendimento) {
        const todosExames = {
          codigo: '',
          descricao: 'Todos',
          id: -1,
          idLegado: -1,
          quantidade: 0,
          tipoItem: 25,
          unidadeMedida: null,
        };
        const listaExames = [todosExames, ...JSON.parse(examesAtendimento)];
        this.setState({ listaExames });
      }
      if (configuracoes) this.setState({ configuracoes });
    }
  };

  componentDidMount() {
    this.alimentaStates();

    const procedimentoPrincipalPermitido = JSON.parse(
      localStorage.getItem('procedimentoPrincipalPermitido')
    );
    if (procedimentoPrincipalPermitido)
      this.setState({ listaProcedimentoPrincipal: procedimentoPrincipalPermitido });
    else
      dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
        this.setState({ listaProcedimentoPrincipal: response.data });
      });

    const procedimentoSecundarioPermitido = JSON.parse(
      localStorage.getItem('procedimentoSecundarioPermitido')
    );
    if (procedimentoSecundarioPermitido)
      this.setState({ listaProcedimentoSecundario: procedimentoSecundarioPermitido });
    else
      dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
        this.setState({ listaProcedimentoSecundario: response.data });
      });

    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
    const caraterAtendimento = configuracoes.caraterPadraoDemanda;
    const caixaOPMEPermitida = JSON.parse(localStorage.getItem('caixaOPMEPermitida'));
    if (caixaOPMEPermitida) this.setState({ listaCaixasOPME: caixaOPMEPermitida });
    else
      dominioDemandaCirurgica
        .get(`/api/itemCaixaOPMEPorCaraterAtendimento/${caraterAtendimento}`)
        .then(response => {
          this.setState({ listaCaixasOPME: response.data });
        });

    const materialConsumivelPermitido = JSON.parse(
      localStorage.getItem('materialConsumivelPermitido')
    );
    if (materialConsumivelPermitido)
      this.setState({ listaMaterialConsumivel: materialConsumivelPermitido });
    else
      dominioDemandaCirurgica.get('/api/itemMaterialConsumivel').then(response => {
        this.setState({ listaMaterialConsumivel: response.data });
      });

    const caixaCirurgicaPermitida = JSON.parse(localStorage.getItem('caixaCirurgicaPermitida'));
    if (caixaCirurgicaPermitida) this.setState({ listaCaixasCirurgicas: caixaCirurgicaPermitida });
    else
      dominioDemandaCirurgica.get('/api/itemCaixaCirurgica').then(response => {
        this.setState({ listaCaixasCirurgicas: response.data });
      });

    const hemocomponentePermitido = JSON.parse(localStorage.getItem('hemocomponentePermitido'));
    if (hemocomponentePermitido) this.setState({ listaHemoderivados: hemocomponentePermitido });
    else
      dominioDemandaCirurgica.get('/api/itemHemoderivados').then(response => {
        this.setState({ listaHemoderivados: response.data });
      });

    const equipamentoPermitido = JSON.parse(localStorage.getItem('equipamentoPermitido'));
    if (equipamentoPermitido) this.setState({ listaEquipamentos: equipamentoPermitido });
    else
      dominioDemandaCirurgica.get('/api/itemEquipamento').then(response => {
        this.setState({ listaEquipamentos: response.data });
      });

    dominioDemandaCirurgica.get('/api/unidadeMedida').then(response => {
      this.setState({ listaUnidadeMedida: response.data });
    });
  }

  setOpenModal = functionQuantidade => {
    this.setState({ handleFuncaoQuantidadeItem: functionQuantidade });
    this.setState({ openModal: true });
  };

  setOpenModalMedida = functionQuantidadeMedida => {
    this.setState({ handleFuncaoQuantidadeItem: functionQuantidadeMedida });
    this.setState({ openModalMedida: true });
  };

  setOpenModalProc = functionQuantidade => {
    this.setState({ handleFuncaoQuantidadeItem: functionQuantidade });
    this.setState({ openModal: true, modalProcedimento: true });
  };

  setCloseModal = () => {
    this.setState({ openModal: false, modalProcedimento: false });
    this.limpaItensSemQuantidade();
  };

  setCloseModalMedida = () => {
    this.setState({ openModalMedida: false });
    this.limpaItensSemQuantidade();
  };

  setQuantidade = () => {
    const quantidade = document.getElementById('quantidade');
    this.state.handleFuncaoQuantidadeItem(quantidade.value);
    quantidade.value = '';
    this.setCloseModal();
  };

  setQuantidadeMedida = e => {
    e.preventDefault();

    const quantidade = document.getElementById('quantidadeMedida');
    const { unidadeMedida } = this.state;
    this.state.handleFuncaoQuantidadeItem(quantidade.value, unidadeMedida);
    quantidade.value = '';
    this.setState({ unidadeMedida: null });
    this.setCloseModalMedida();
  };

  limpaItensSemQuantidade = () => {
    let lista = [];

    //  Caixas OPME
    lista = this.state.caixasOPME.filter(caixa => {
      return caixa.quantidade !== 0 && caixa.quantidade > 0;
    });

    this.setState({ caixasOPME: lista });
    localStorage.setItem('caixasOPME', JSON.stringify(lista));

    // Materiais consumíveis
    lista = this.state.materiaisConsumiveis.filter(material => {
      return material.quantidade !== 0 && material.quantidade > 0;
    });

    this.setState({ materiaisConsumiveis: lista });
    localStorage.setItem('materiaisConsumiveis', JSON.stringify(lista));

    //  Hemoderivados
    lista = this.state.hemoderivados.filter(hemoderivado => {
      return hemoderivado.quantidade !== 0 && hemoderivado.quantidade > 0;
    });

    this.setState({ hemoderivados: lista });
    localStorage.setItem('hemoderivados', JSON.stringify(lista));

    //  Procedimento Principal
    if (this.state.procedimentoPrincipal && this.state.procedimentoPrincipal.quantidade < 1) {
      this.setState({ procedimentoPrincipal: null });
    }

    //  Procedimentos Secundários
    lista = this.state.procedimentosSecundarios.filter(proc => {
      return proc.quantidade !== 0 && proc.quantidade > 0;
    });

    this.setState({ procedimentosSecundarios: lista });
    localStorage.setItem('procedimentosSecundarios', JSON.stringify(lista));
  };

  sugerirDiariasPrevistas = procedimentoPrincipalStorage => {
    let procedimentoPrincipal = null;

    if (procedimentoPrincipalStorage)
      procedimentoPrincipal = JSON.parse(procedimentoPrincipalStorage);
    else procedimentoPrincipal = this.state.procedimentoPrincipal;

    let tempoProcedimentoPrincipal = 0;
    if (procedimentoPrincipal) tempoProcedimentoPrincipal = procedimentoPrincipal.tempo;
    let maiorTempoProcedimentoSecundario = 0;
    if (this.state.procedimentosSecundarios.length > 0)
      maiorTempoProcedimentoSecundario = this.state.procedimentosSecundarios.reduce(
        (a, b) => (b.tempo > a.tempo ? b.y : a),
        this.state.procedimentosSecundarios[0].tempo
      );

    const maiorValor = Math.max(tempoProcedimentoPrincipal, maiorTempoProcedimentoSecundario);

    this.setState({ diariasPrevistas: maiorValor });
    localStorage.setItem('diariasPrevistas', maiorValor);
    setPendencia(2, PendenciasWizard.diariasPrevistas);
  };

  //  #region FUNÇÕES CAIXAS OPME
  handleConfirmaQuantidadeOPME = quantidade => {
    const lista = this.state.caixasOPME;

    lista[lista.length - 1].quantidade = quantidade;

    if (this.state.checkItemEventual) {
      lista[lista.length - 1].itemEventual = true;
      lista[lista.length - 1].justificativaEventual = this.state.justificativaEventual;
    }

    localStorage.setItem('caixasOPME', JSON.stringify(lista));

    this.setCloseModal();

    this.setState({ checkItemEventual: false, justificativaEventual: null });
  };

  setOPME = caixas => {
    this.setState({ caixasOPME: caixas });
  };

  renderTagOPME = () => {
    return this.state.caixasOPME.map(caixa => {
      const label = `${caixa.descricao} x${caixa.quantidade}` || caixa;
      return (
        <Chip
          key={label}
          label={label}
          deleteIcon={<CancelIcon />}
          className="div-chip wrap-chip"
          onDelete={() => {
            const lista = this.state.caixasOPME.filter(entry => entry !== caixa);
            this.setOPME(lista);
            localStorage.setItem('caixasOPME', JSON.stringify(lista));
          }}
        />
      );
    });
  };
  // #endregion

  //  #region FUNÇÕES MATERIAIS CONSUMIVEIS
  handleConfirmaQuantidadeMateriais = quantidade => {
    const lista = this.state.materiaisConsumiveis;

    lista[lista.length - 1].quantidade = quantidade;

    if (this.state.checkItemEventual) {
      lista[lista.length - 1].itemEventual = true;
      lista[lista.length - 1].justificativaEventual = this.state.justificativaEventual;
    }

    localStorage.setItem('materiaisConsumiveis', JSON.stringify(lista));

    this.setCloseModal();

    this.setState({ checkItemEventual: false, justificativaEventual: null });
  };

  setMateriaisConsumiveis = materiais => {
    this.setState({ materiaisConsumiveis: materiais });
  };

  renderTagMateriaisConsumiveis = () => {
    return this.state.materiaisConsumiveis.map(material => {
      const label = `${material.descricao} x${material.quantidade}` || material;
      return (
        <Chip
          key={label}
          label={label}
          deleteIcon={<CancelIcon />}
          className="div-chip wrap-chip"
          onDelete={() => {
            const lista = this.state.materiaisConsumiveis.filter(entry => entry !== material);
            this.setMateriaisConsumiveis(lista);
            localStorage.setItem('materiaisConsumiveis', JSON.stringify(lista));
          }}
        />
      );
    });
  };
  //  #endregion

  //  #region FUNÇÕES HEMODERIVADOS
  handleConfirmaQuantidadeHemoderivados = (quantidade, unidadeMedida) => {
    const lista = this.state.hemoderivados;

    lista[lista.length - 1].quantidade = quantidade;
    lista[lista.length - 1].unidadeMedida = unidadeMedida;

    localStorage.setItem('hemoderivados', JSON.stringify(lista));

    this.setCloseModal();
  };

  setHemoderivado = hemoderivado => {
    this.setState({ hemoderivados: hemoderivado });
  };

  renderTagHemoderivado = () => {
    return this.state.hemoderivados.map(hemoderivado => {
      const label =
        `${hemoderivado.descricao}${hemoderivado.unidadeMedida
          ? ` - ${hemoderivado.quantidade} ${hemoderivado.unidadeMedida.descricao}  `
          : ''
        }` || hemoderivado;
      return (
        <Chip
          key={label}
          label={label}
          deleteIcon={<CancelIcon />}
          className="div-chip wrap-chip"
          onDelete={() => {
            const lista = this.state.hemoderivados.filter(entry => entry !== hemoderivado);
            this.setHemoderivado(lista);
            localStorage.setItem('hemoderivados', JSON.stringify(lista));
          }}
        />
      );
    });
  };
  // #endregion

  //  #region FUNÇÕES PROCEDIMENTOS SECUNDÁRIOS
  handleConfirmaQuantidadeProcSec = async quantidade => {
    const lista = this.state.procedimentosSecundarios;
    const duracaoEstimadaAux = localStorage.getItem('duracaoEstimada');
    if (duracaoEstimadaAux.length > 0) {
      Number(duracaoEstimadaAux);
    }

    lista[lista.length - 1].quantidade = quantidade;

    const duracaoProcSecSemDuracao = 120 * quantidade;
    const duracaoProcSecComDuracao = lista[lista.length - 1]?.duracao * quantidade;

    if (lista[lista.length - 1].duracao === 0 || lista[lista.length - 1].duracao === null) {
      await this.setState(prevState => ({
        duracaoEstimada: Number(prevState.duracaoEstimada) + duracaoProcSecSemDuracao,
      }));
    } else {
      await this.setState(prevState => ({
        duracaoEstimada: Number(prevState.duracaoEstimada) + duracaoProcSecComDuracao,
      }));
    }

    localStorage.setItem('duracaoEstimada', Number(this.state.duracaoEstimada));
    localStorage.setItem('procedimentosSecundarios', JSON.stringify(lista));

    this.setCloseModal();
    this.sugerirDiariasPrevistas();
  };

  setProcSec = proc => {
    this.setState({ procedimentosSecundarios: proc });
  };

  renderTagProcSec = () => {
    return this.state.procedimentosSecundarios.map(proc => {
      const label = `${proc.descricao} x${proc.quantidade}` || proc;
      return (
        <Chip
          key={label}
          label={label}
          deleteIcon={<CancelIcon />}
          className="div-chip wrap-chip"
          onDelete={() => {
            const lista = this.state.procedimentosSecundarios.filter(entry => entry !== proc);
            this.setProcSec(lista);
            localStorage.setItem('procedimentosSecundarios', JSON.stringify(lista));
          }}
        />
      );
    });
  };
  //  #endregion

  //  #region FUNÇÕES PROCEDIMENTO PRINCIPAL
  handleConfirmaQuantidadeProcPrin = quantidade => {
    const proc = this.state.procedimentoPrincipal;
    const duracaoEstimadaAux = this.state.duracaoEstimada;

    proc.quantidade = quantidade;

    localStorage.setItem('procedimentoPrincipal', JSON.stringify(proc));

    this.setState({
      duracaoEstimada: duracaoEstimadaAux + this.state.procedimentoPrincipal?.duracao * quantidade,
    });
    localStorage.setItem(
      'duracaoEstimada',
      duracaoEstimadaAux + this.state.procedimentoPrincipal?.duracao * quantidade
    );

    this.setCloseModal();
    this.sugerirDiariasPrevistas();
  };
  //  #endregion

  carregarPedidosCirurgiaPacienteProcedimento = idProcedimento => {
    const novoPaciente = JSON.parse(localStorage.getItem('novoPaciente'));

    if (novoPaciente) {
      this.colocaQuantidadeProcedimentoPrincipal();
      return;
    }

    const paciente = JSON.parse(localStorage.getItem('paciente'));

    dominioDemandaCirurgica
      .get(`/api/demandaPacienteProcedimento/${paciente.SEQ_PACIENTE}/${idProcedimento}`)
      .then(res => {
        if (res.data.length > 0)
          this.setState({
            pedidosCirurgiaPacienteProcedimento: res.data,
            abrePedidoCirurgiaPacienteProcedimento: true,
          });
        else {
          this.colocaQuantidadeProcedimentoPrincipal();
        }
      });
  };

  colocaQuantidadeProcedimentoPrincipal = () => {
    this.setOpenModalProc(this.handleConfirmaQuantidadeProcPrin);
    setPendencia(2, PendenciasWizard.procedimentoPrincipal);
  };

  isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 13000,
    });
  }

  render() {
    return (
      <Container>
        <Toast
          className="toast-dados-solicitacao"
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
        <DialogPrime
          header="Aviso de Duplicidade"
          visible={this.state.abrePedidoCirurgiaPacienteProcedimento}
          style={{ width: '65vw' }}
          onHide={() => {
            if (!this.state.continuaProcedimentoDuplicado) {
              localStorage.removeItem('procedimentoPrincipal');
              this.setState({
                procedimentoPrincipal: null,
              });
            }
            this.setState({
              abrePedidoCirurgiaPacienteProcedimento: false,
              continuaProcedimentoDuplicado: false,
            });
            document.getElementById('procedimentoPrincipal').focus();
          }}
        >
          <strong>
            Atenção! Esse paciente já possui pedido de cirurgia para o procedimento selecionado.
          </strong>
          <br />
          <br />
          <div style={{ overflow: 'auto', height: '58vh' }}>
            {this.state.pedidosCirurgiaPacienteProcedimento.map(pedidoCirurgia => {
              let dataCirurgia = null;
              if (pedidoCirurgia.dataCirurgia) {
                dataCirurgia = new Date(pedidoCirurgia.dataCirurgia.replace('Z', ''));
              }
              const dataCirurgiaFormatada = dataCirurgia
                ? format(dataCirurgia, 'dd/MM/yyyy HH:mm')
                : 'Não Informado';

              const dataInclusao = new Date(pedidoCirurgia.dataInclusao.replace('Z', ''));
              const dataInclusaoFormatada = format(dataInclusao, 'dd/MM/yyyy HH:mm');

              return (
                <Card key={pedidoCirurgia.id}>
                  <CardHeader color="info" id="centroMeusPedidos">
                    <strong>{`Nº Pedido: ${pedidoCirurgia.codigo}`}</strong>
                  </CardHeader>
                  <CardBody>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Paciente:</strong>
                      </span>
                      <span>{pedidoCirurgia.paciente}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Atendimento Origem:</strong>
                      </span>
                      <span>{pedidoCirurgia.atendimento}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Requisitante:</strong>
                      </span>
                      <span>{pedidoCirurgia.profissionalRequisitante}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Data da Solicitação:</strong>
                      </span>
                      <span>{dataInclusaoFormatada}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Data da Cirurgia:</strong>
                      </span>
                      <span>{dataCirurgiaFormatada}</span>
                    </div>
                  </CardBody>
                </Card>
              );
            })}
          </div>
          <br />
          <div style={{ float: 'right' }}>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginRight: '5px', marginBottom: '15px' }}
              onClick={() => {
                this.setState({
                  abrePedidoCirurgiaPacienteProcedimento: false,
                });
              }}
            >
              Cancelar
            </Button>
            <Button
              style={{ marginBottom: '15px' }}
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  abrePedidoCirurgiaPacienteProcedimento: false,
                  continuaProcedimentoDuplicado: true,
                });
                this.colocaQuantidadeProcedimentoPrincipal();
              }}
            >
              Continuar
            </Button>
          </div>
        </DialogPrime>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.openModal}
          onClose={this.setCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.openModal}>
            <div className="modal-quantidade">
              <button
                type="button"
                onClick={this.setCloseModal}
                style={{ float: 'right', cursor: 'pointer', background: 'none', border: 'none' }}
              >
                <FaWindowClose color="black" size={24} />
              </button>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h3>Quantidade</h3>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    autoComplete="off"
                    name="quantidade"
                    variant="outlined"
                    type="number"
                    fullWidth
                    id="quantidade"
                    label="Quantidade"
                    style={{ marginBottom: '30px' }}
                    defaultValue={1}
                    onChange={e => {
                      if (e.target.value.length > 4) {
                        e.target.value = e.target.value.substring(0, 4);
                      }
                      if (e.target.value.toString().includes('-')) {
                        e.target.value = 1;
                      }
                      if (e.target.value === 0) {
                        e.target.value = 1;
                      }
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        this.setQuantidade();
                      }
                    }}
                    inputProps={{
                      min: 1,
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkEventual"
                        checked={this.state.checkItemEventual}
                        onChange={e => this.setState({ checkItemEventual: e.target.checked })}
                        color="primary"
                      />
                    }
                    style={{ marginBottom: '20px', display: !this.state.modalProcedimento ? 'block' : 'none', color: '#FF0000' }}
                    label="Item Eventual"
                  />
                  <TextField
                    autoComplete="off"
                    name="justificativa"
                    variant="outlined"
                    fullWidth
                    id="justificativa"
                    label="Justificativa"
                    InputLabelProps={{ shrink: true }}
                    value={this.state.justificativaEventual}
                    onChange={e => {
                      this.setState({ justificativaEventual: e.target.value ?? null });
                    }}
                    inputProps={{ maxLength: 200, style: { textTransform: 'uppercase' } }}
                    style={{ marginBottom: '20px', display: this.state.checkItemEventual ? 'block' : 'none' }}
                    multiline
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ float: 'right' }}
                    onClick={() => {
                      if (this.state.checkItemEventual && !this.state.justificativaEventual) {
                        this.showWarn('Informe a justificativa para o item eventual.', 'warn');
                        return;
                      }

                      this.setQuantidade();
                    }}
                  >
                    Confirmar
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.openModalMedida}
          onClose={this.setCloseModalMedida}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.openModalMedida}>
            <div className="modal-quantidade-medida">
              <button
                type="button"
                onClick={this.setCloseModalMedida}
                style={{ float: 'right', cursor: 'pointer', background: 'none', border: 'none' }}
              >
                <FaWindowClose color="black" size={24} />
              </button>
              <form onSubmit={this.setQuantidadeMedida}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <h3>Quantidade e Medida</h3>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      autoComplete="off"
                      name="quantidadeMedida"
                      variant="outlined"
                      type="number"
                      fullWidth
                      id="quantidadeMedida"
                      label="Quantidade"
                      style={{ marginBottom: '30px' }}
                      defaultValue={1}
                      onChange={e => {
                        if (e.target.value.length > 4) {
                          e.target.value = e.target.value.substring(0, 4);
                        }
                        if (e.target.value.toString().includes('-')) {
                          e.target.value = 1;
                        }
                        if (e.target.value === 0) {
                          e.target.value = 1;
                        }
                      }}
                      inputProps={{
                        min: 1,
                      }}
                      required
                    />
                    <Autocomplete
                      id="unidadeMedida"
                      options={this.state.listaUnidadeMedida}
                      getOptionLabel={option => `${option.descricao}`}
                      renderTags={() => { }}
                      onChange={(e, values) => {
                        this.setState({ unidadeMedida: values });
                      }}
                      value={this.state.unidadeMedida}
                      filterSelectedOptions
                      renderInput={params => (
                        <TextField
                          {...params}
                          variant="outlined"
                          required
                          label="Unidade de Medida"
                        />
                      )}
                    />
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      style={{ float: 'right', marginTop: '10px' }}
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          </Fade>
        </Modal>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Procedimentos Cirúrgicos</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="procedimentoPrincipal"
              options={this.state.listaProcedimentoPrincipal}
              getOptionLabel={option => `${option.descricao.trim()} x${option.quantidade}`}
              fullWidth
              value={this.state.procedimentoPrincipal}
              onChange={(e, value) => {
                if (value !== null) {
                  this.carregarPedidosCirurgiaPacienteProcedimento(value.id);
                  this.setState({ procedimentoPrincipal: value });
                } else {
                  this.setState({ procedimentoPrincipal: value });
                  localStorage.removeItem('procedimentoPrincipal');
                }
              }}
              renderInput={params => (
                <TextField {...params} label="Procedimento Principal" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="procedimentosSecundarios"
              options={this.state.listaProcedimentoSecundario}
              getOptionLabel={option => `${option.descricao}`}
              value={this.state.procedimentosSecundarios}
              renderTags={() => { }}
              onChange={(e, values) => {
                this.setProcSec(values);
                this.setOpenModalProc(this.handleConfirmaQuantidadeProcSec);
              }}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="Procedimentos Secundários" />
              )}
            />
            <div className="chip">{this.renderTagProcSec()}</div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              autoComplete="off"
              name="duracaoEstimada"
              type="number"
              variant="outlined"
              fullWidth
              id="duracaoEstimada"
              error={
                this.state.duracaoEstimada < 120 &&
                !this.state.procedimentoPrincipal?.duracao &&
                this.state.codigoProcedimentoSequencial !==
                  this.state.procedimentoPrincipal?.codigo.slice(0, 6)
              }
              helperText={
                this.state.duracaoEstimada < 120 &&
                !this.state.procedimentoPrincipal?.duracao &&
                this.state.codigoProcedimentoSequencial !==
                  this.state.procedimentoPrincipal?.codigo.slice(0, 6)
                  ? 'Você não pode fazer um pedido de cirurgia com duração abaixo de 120 minutos'
                  : ''
              }
              disabled={
                this.state.duracaoEstimadaDesabilitada ||
                this.state.procedimentoPrincipal?.duracao > 0 ||
                this.state.codigoProcedimentoSequencial ===
                  this.state.procedimentoPrincipal?.codigo.slice(0, 6)
              }
              label="Duração estimada (minutos)"
              value={this.state.duracaoEstimada}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = 0;
                }
                if (e.target.value.length > 4) {
                  e.target.value = e.target.value.substring(0, 4);
                }

                localStorage.setItem('duracaoEstimada', e.target.value);
                this.setState({ duracaoEstimada: Number(e.target.value) });
                setPendencia(2, PendenciasWizard.duracaoEstimada);
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="diariasPrevistas"
              variant="outlined"
              fullWidth
              id="diariasPrevistas"
              disabled={this.state.diariaPrevistaDesabilitada}
              label="Diárias Previstas"
              InputLabelProps={{ shrink: true }}
              type="number"
              value={this.state.diariasPrevistas}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = '';
                }

                if (e.target.value.toString().length >= 3) {
                  alert('valor maximo:99');
                  e.target.value = '';
                }

                if (e.target.value.toString().includes(',')) {
                  alert('Valor decimal não permitido');
                  e.target.value = '';
                }
                if (e.target.value.toString().includes('.')) {
                  alert('Valor decimal não permitido');
                  e.target.value = '';
                }
                localStorage.setItem('diariasPrevistas', e.target.value);
                this.setState({ diariasPrevistas: e.target.value });
                setPendencia(2, PendenciasWizard.diariasPrevistas);
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                },
                style: {
                  height: '52px',
                },
              }}
            />
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Caixas OPME e/ou Materiais Consumíveis</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="caixasOPME"
              options={this.state.listaCaixasOPME}
              getOptionLabel={option => `${option.descricao}`}
              value={this.state.caixasOPME}
              renderTags={() => { }}
              onChange={(e, values) => {
                this.setOPME(values);
                this.setOpenModal(this.handleConfirmaQuantidadeOPME);
              }}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="Caixas OPME" />
              )}
            />
            <div className="chip">{this.renderTagOPME()}</div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="materialConsumivel"
              options={this.state.listaMaterialConsumivel}
              getOptionLabel={option => `${option.descricao}`}
              renderTags={() => { }}
              onChange={(e, values) => {
                this.setMateriaisConsumiveis(values);
                this.setOpenModal(this.handleConfirmaQuantidadeMateriais);
              }}
              value={this.state.materiaisConsumiveis}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="Material Consumível" />
              )}
            />
            <div className="chip">{this.renderTagMateriaisConsumiveis()}</div>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Caixa Cirúrgica</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="caixasCirurgicas"
              options={this.state.listaCaixasCirurgicas}
              getOptionLabel={option => `${option.descricao}`}
              onChange={(e, values) => {
                localStorage.setItem('caixasCirurgicas', JSON.stringify(values));
                this.setState({ caixasCirurgicas: values });
              }}
              value={this.state.caixasCirurgicas}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} label="Caixa Cirúrgica" variant="outlined" />
              )}
            />
          </Grid>
        </Grid>
        <br />
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Hemocomponentes</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="hemoderivados"
              options={this.state.listaHemoderivados}
              getOptionLabel={option => `${option.descricao}`}
              renderTags={() => { }}
              onChange={(e, values) => {
                this.setHemoderivado(values);
                this.setOpenModalMedida(this.handleConfirmaQuantidadeHemoderivados);
              }}
              value={this.state.hemoderivados}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="Hemocomponentes" />
              )}
            />
            <div className="chip">{this.renderTagHemoderivado()}</div>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Equipamentos</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="equipamentos"
              options={this.state.listaEquipamentos}
              getOptionLabel={option => `${option.descricao}`}
              onChange={(e, values) => {
                localStorage.setItem('equipamentos', JSON.stringify(values));
                this.setState({ equipamentos: values });
              }}
              value={this.state.equipamentos}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} label="Equipamentos" variant="outlined" />
              )}
            />
          </Grid>
          <br />
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Exames</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="exames"
              disabled={this.state.novoPaciente === null}
              options={this.state.listaExames}
              getOptionLabel={option => `${option.codigo} - ${option.descricao}`}
              value={this.state.exames}
              onChange={(e, values) => {
                localStorage.setItem('exames', JSON.stringify(values));
                this.setState({ exames: values });
              }}
              disableCloseOnSelect
              renderOption={(props, option) => {
                if (option.id > -1)
                  return (
                    <div>
                      <Checkbox
                        name={option.descricao}
                        value={option}
                        checked={
                          this.state.exames.filter(exame => exame.id === option.id).length > 0
                        }
                        onChange={event => {
                          if (event.target.checked) {
                            const examesSelecionados = [...new Set([...this.state.exames, option])];
                            localStorage.setItem('exames', JSON.stringify(examesSelecionados));
                            this.setState({ exames: examesSelecionados });
                          } else {
                            const examesSelecionados = this.state.exames.filter(
                              exame => exame.id !== option.id
                            );
                            localStorage.setItem('exames', JSON.stringify(examesSelecionados));
                            this.setState({ exames: examesSelecionados });
                          }
                        }}
                      />
                      {option.descricao}
                    </div>
                  );
                return (
                  <div>
                    <Checkbox
                      name={option.descricao}
                      value={option}
                      checked={this.state.exames.length === this.state.listaExames.length - 1}
                      onClick={event => {
                        if (event.target.checked) {
                          const examesSelecionados = this.state.listaExames.filter(
                            exame => exame.id > -1
                          );
                          localStorage.setItem('exames', JSON.stringify(examesSelecionados));
                          this.setState({ exames: examesSelecionados });
                        } else {
                          const examesSelecionados = [];
                          localStorage.setItem('exames', JSON.stringify(examesSelecionados));
                          this.setState({ exames: examesSelecionados });
                        }
                      }}
                    />
                    {option.descricao}
                  </div>
                );
              }}
              renderInput={params => <TextField {...params} label="Exames" variant="outlined" />}
            />
          </Grid>
          <br />
        </Grid>
        <br />
        <Divider />
        <br />
      </Container>
    );
  }
}

export default ItensCirurgia;
